/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import ReactDOM from 'react-dom';
import url from 'url';
import { createBrowserHistory as createHistory } from 'history';
import { ResultContainer } from '../shared/components/ResultContainer';
import Router from '../shared/components/Router';

import './client.scss';
import './LegacyReset.scss';

if (window.__INITIAL_WEBSEARCHRESULT_STATE__.standalone) {
  // eslint-disable-next-line no-unused-expressions
  import('./IdunReset.scss');
}

const history = createHistory();
const location = url.parse(
  `${window.location.pathname}${window.location.search}${window.location.hash}`,
  true,
);
const dest = document.getElementById('websearchresult');

const app = (
  <Router location={location} history={history}>
    <ResultContainer {...window.__INITIAL_WEBSEARCHRESULT_STATE__} />
  </Router>
);
if (ReactDOM.hydrate) {
  ReactDOM.hydrate(app, dest);
} else {
  ReactDOM.render(app, dest);
}

if (process.env.NODE_ENV !== 'production') {
  window.React = React; // enable debugger
}
